import coreAr from './ar.json'

const messages = {
  ar: {
    ...coreAr,
  },
}

export default messages
